<div
  [class.drop-zone]="enableDropZone"
  (click)="openUpload()"
  tabindex="0"
  (keyup.space)="openUpload()"
>
  <ng-content></ng-content>
  <div
    *ngIf="enableDropZone && showDropText"
    class="drop-zone__text"
  >
    {{ "COMMON.LABELS.DROP_FILES_HERE" | translate }}
  </div>
</div>
<input
  type="file"
  name="file"
  (change)="fileChanged($event)"
  id="fileInput"
  multiple="true"
  class="d-none"
  [accept]="accept || validFileTypes"
  #fileInput
/>
